export class ConsultaBinParams {
    public bin:string = '';
}
